import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-twitter\">\n<rect width=\"16\" height=\"16\" rx=\"4\" fill=\"black\" />\n<path d=\"M9.43632 11.6L4.63632 4.4H6.34151L11.1415 11.6H9.43632Z\" stroke=\"white\" stroke-width=\"0.8\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.0001 4H11.889L8.65251 7.641L8.31063 7.02562L11.0001 4ZM7.11603 8.36954L3.88895 12H4.77784L7.46385 8.97824L7.11603 8.36954Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol